import { render, staticRenderFns } from "./Loads.vue?vue&type=template&id=2f9eb3c0"
import script from "./Loads.vue?vue&type=script&lang=js"
export * from "./Loads.vue?vue&type=script&lang=js"
import style0 from "./Loads.vue?vue&type=style&index=0&id=2f9eb3c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports